/**
 * @generated SignedSource<<3c0d6a967fe62746a95c1803f06ec282>>
 * @relayHash 841419d914d017e7fd3bcecf2326227d
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 841419d914d017e7fd3bcecf2326227d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type MilestoneOrderField = "ALPHABETICAL" | "COMPLETED" | "CREATED_AT" | "DUE_DATE" | "ISSUES" | "NUMBER" | "UPDATED_AT" | "%future added value";
export type MilestoneState = "CLOSED" | "OPEN" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type RepositoryMilestoneIndexPageQuery$variables = {
  first?: number | null | undefined;
  name: string;
  orderDirection?: OrderDirection | null | undefined;
  orderField?: MilestoneOrderField | null | undefined;
  owner: string;
  skip?: number | null | undefined;
  state: MilestoneState;
};
export type RepositoryMilestoneIndexPageQuery$data = {
  readonly repository: Result<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RepositoryMilestoneIndexPageContentInternal">;
  } | null | undefined, unknown>;
};
export type RepositoryMilestoneIndexPageQuery = {
  response: RepositoryMilestoneIndexPageQuery$data;
  variables: RepositoryMilestoneIndexPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 50,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": "DESC",
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v3 = {
  "defaultValue": "CREATED_AT",
  "kind": "LocalArgument",
  "name": "orderField"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "owner"
},
v5 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "skip"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v7 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v10 = {
  "kind": "Variable",
  "name": "skip",
  "variableName": "skip"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPush",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v14 = [
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RepositoryMilestoneIndexPageQuery",
    "selections": [
      {
        "kind": "CatchField",
        "field": {
          "alias": null,
          "args": (v7/*: any*/),
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v8/*: any*/),
              "action": "THROW"
            },
            {
              "args": [
                (v9/*: any*/),
                {
                  "kind": "Variable",
                  "name": "orderDirection",
                  "variableName": "orderDirection"
                },
                {
                  "kind": "Variable",
                  "name": "orderField",
                  "variableName": "orderField"
                },
                (v10/*: any*/),
                {
                  "kind": "Variable",
                  "name": "state",
                  "variableName": "state"
                }
              ],
              "kind": "FragmentSpread",
              "name": "RepositoryMilestoneIndexPageContentInternal"
            }
          ],
          "storageKey": null
        },
        "to": "RESULT"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RepositoryMilestoneIndexPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameWithOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v9/*: any*/),
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "direction",
                    "variableName": "orderDirection"
                  },
                  {
                    "kind": "Variable",
                    "name": "field",
                    "variableName": "orderField"
                  }
                ],
                "kind": "ObjectValue",
                "name": "orderBy"
              },
              (v10/*: any*/),
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "states.0",
                    "variableName": "state"
                  }
                ],
                "kind": "ListValue",
                "name": "states"
              }
            ],
            "concreteType": "MilestoneConnection",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MilestoneEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Milestone",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "closed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "closedIssueCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dueOn",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "openIssueCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progressPercentage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Repository",
                        "kind": "LinkedField",
                        "name": "repository",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "state",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "open",
            "args": [
              (v13/*: any*/),
              {
                "kind": "Literal",
                "name": "states",
                "value": "OPEN"
              }
            ],
            "concreteType": "MilestoneConnection",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": "milestones(first:0,states:\"OPEN\")"
          },
          {
            "alias": "closed",
            "args": [
              (v13/*: any*/),
              {
                "kind": "Literal",
                "name": "states",
                "value": "CLOSED"
              }
            ],
            "concreteType": "MilestoneConnection",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": false,
            "selections": (v14/*: any*/),
            "storageKey": "milestones(first:0,states:\"CLOSED\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "841419d914d017e7fd3bcecf2326227d",
    "metadata": {},
    "name": "RepositoryMilestoneIndexPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8423c697f54d11a6109166885b0017fa";

export default node;
